import * as React from "react";

function SvgDistribution({ title, titleId, ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M32 11.25c-.13.268-.356.346-.64.345-1.552-.005-3.103 0-4.654-.003-.5 0-.642-.155-.642-.664V9.11h-4v.313c0 2.165.004 4.33-.008 6.5 0 .239.083.344.288.437.588.263 1.173.535 1.743.836.154.081.348.27.354.417.035.8.025 1.602.012 2.403-.004.263-.174.418-.444.43-.258.011-.433-.154-.466-.443a3.636 3.636 0 01-.011-.405V18.43c-.12.045-.203.071-.28.108l-6.534 3.11c-.167.078-.25.166-.25.37.007 2.833.009 5.665.006 8.495 0 .071.012.143.022.262l.292-.135c2.16-1.028 4.319-2.054 6.479-3.079.214-.1.274-.227.272-.453-.01-1.614-.005-3.227-.005-4.842 0-.51.148-.734.476-.728.328.005.462.223.462.742 0 1.729-.008 3.457.007 5.187.003.395-.133.625-.5.796-2.623 1.23-5.237 2.485-7.853 3.734h-.25l-2.275-1.093-.196-.095c-.296-.158-.4-.383-.291-.633.114-.262.375-.353.682-.214.474.214.938.445 1.41.668.092.043.188.08.307.134.008-.125.018-.218.018-.308V22.05c0-.178-.02-.301-.214-.393a1224.614 1224.614 0 01-6.648-3.163c-.045-.021-.092-.04-.178-.075-.01.125-.022.224-.022.321 0 2.791 0 5.583-.007 8.374 0 .234.077.349.285.445 1.028.477 2.05.969 3.072 1.458.112.054.264.097.313.188.08.149.171.372.114.495-.066.14-.282.23-.451.288-.085.03-.216-.051-.318-.1-1.175-.556-2.345-1.124-3.523-1.67-.307-.142-.43-.346-.43-.68.007-3.238.007-6.477 0-9.716 0-.337.134-.536.438-.677 1.197-.558 2.383-1.138 3.58-1.695.207-.095.267-.21.263-.425-.013-.673-.005-1.348-.005-2.059h-1.562c-.488 0-.711-.144-.72-.457-.009-.323.227-.48.73-.48h1.75c.605 0 .739.133.74.728v2.106c.135-.063.237-.1.336-.148.826-.393 1.657-.777 2.475-1.188.309-.154.579-.172.884-.005.316.173.65.312 1.01.483V3.463h-3.528V5.18c0 .636-.12.757-.74.757h-4.53c-.523 0-.666-.141-.666-.669 0-1.54 0-3.083-.004-4.624 0-.287.074-.51.34-.644h5.312c.25.187.296.447.291.74-.01.579 0 1.158 0 1.76h3.883c.437 0 .596.16.609.602.003.094 0 .188 0 .281 0 3.584-.002 7.167-.006 10.75 0 .258.081.387.312.49.646.288 1.28.603 1.918.906.154.074.313.145.493.231V8.867c0-.58.13-.71.72-.711h4.216V6.323c0-.511.143-.665.64-.665 1.552-.004 3.105 0 4.656-.004.285 0 .51.077.641.346v5.25zm-16.49 3.385a.474.474 0 00-.112.016c-.835.397-1.672.79-2.5 1.2-.08.04-.148.188-.15.29-.012.75-.009 1.5-.006 2.25 0 .331-.096.734.056.974.152.241.558.32.856.464.605.293 1.213.58 1.855.886v-6.08zm2.92.892v4.21c.049 0 .084.01.108 0 .817-.387 1.635-.772 2.445-1.172.074-.036.133-.174.137-.267.014-.416 0-.832.01-1.25.007-.183-.054-.279-.222-.354-.53-.24-1.051-.5-1.577-.746-.288-.137-.58-.27-.902-.421zM8.93.953v2.149h4.027V.953H8.93zm22.108 7.818V6.613h-4.013V8.77h4.013zM16.492 20.707c.286-.134.547-.237.784-.379a.427.427 0 00.188-.303c.012-1.581.009-3.163.005-4.744 0-.085-.023-.216-.079-.25-.281-.157-.578-.287-.895-.437l-.003 6.113zM8.931 4.974h4.026v-.89H8.932l-.001.89zm22.107 5.662v-.901h-4.015v.904l4.015-.003zm-19.253 5.73l-2.693 1.288 2.695 1.282-.002-2.57zm11.122 1.288l-.83-.393v.79l.83-.397z"
        fill="url(#distribution_svg__paint0_linear_3_2397)"
      />
      <path
        d="M.002 9.874c.131-.269.356-.347.64-.346 1.551.005 3.1 0 4.651.004.5 0 .645.155.646.659v1.839h1.707c.135-.003.27.002.405.017.268.034.408.2.402.466-.006.25-.15.42-.402.433-.438.022-.875.017-1.313.02h-.802v1.839c0 .504-.146.659-.645.66-1.55.003-3.1 0-4.651.003-.284 0-.51-.077-.64-.346l.002-5.248zm.964.604v2.157h4.01v-2.157H.966zM.95 14.503h4.032v-.883H.95v.883z"
        fill="url(#distribution_svg__paint1_linear_3_2397)"
      />
      <path
        d="M10.939 2.494a4.408 4.408 0 01-.5-.004c-.262-.03-.424-.195-.426-.456-.001-.26.157-.441.42-.46a7.146 7.146 0 011.027 0c.26.022.415.202.408.467-.007.265-.172.42-.432.449-.167.01-.334.011-.5.004h.003z"
        fill="url(#distribution_svg__paint2_linear_3_2397)"
      />
      <path
        d="M29.045 7.232c.165-.008.331-.008.497 0 .266.029.412.188.41.459 0 .25-.138.424-.391.437-.352.02-.704.02-1.056 0-.25-.014-.391-.187-.394-.437-.004-.267.139-.433.406-.46.176-.009.352-.008.528.002z"
        fill="url(#distribution_svg__paint3_linear_3_2397)"
      />
      <path
        d="M2.983 11.084c.177.01.354.007.527.031.254.035.384.201.382.45-.003.25-.137.427-.39.442-.352.02-.704.02-1.055 0-.25-.014-.393-.184-.397-.437-.004-.267.138-.434.405-.462.176-.01.353-.01.528 0v-.024z"
        fill="url(#distribution_svg__paint4_linear_3_2397)"
      />
      <defs>
        <linearGradient
          id="distribution_svg__paint0_linear_3_2397"
          x1={2.935}
          y1={16.171}
          x2={36.283}
          y2={16.171}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="#00007E" />
        </linearGradient>
        <linearGradient
          id="distribution_svg__paint1_linear_3_2397"
          x1={-1.585}
          y1={12.53}
          x2={9.933}
          y2={12.53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="#00007E" />
        </linearGradient>
        <linearGradient
          id="distribution_svg__paint2_linear_3_2397"
          x1={9.666}
          y1={2.033}
          x2={12.193}
          y2={2.033}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="#00007E" />
        </linearGradient>
        <linearGradient
          id="distribution_svg__paint3_linear_3_2397"
          x1={27.765}
          y1={7.689}
          x2={30.274}
          y2={7.689}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="#00007E" />
        </linearGradient>
        <linearGradient
          id="distribution_svg__paint4_linear_3_2397"
          x1={1.705}
          y1={11.558}
          x2={4.214}
          y2={11.558}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="#00007E" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgDistribution;
